import i from "./QuantityModifier.mjs";
import { QuantityModifierMax as n } from "./QuantityModifier.mjs";
import "../../../jsx-runtime-c20f6c15.mjs";
import "react";
import "clsx";
import "../../../shared/icons/add-fill.svg.mjs";
import "../../../shared/icons/minus-fill.svg.mjs";
import "../../../shared/icons/trash-bin-outline-1.svg.mjs";
import "../Button/Button.mjs";
import "../Spinner/Spinner.mjs";
import "../BodyText/BodyText.mjs";
export {
  n as QuantityModifierMax,
  i as default
};
